import { Base } from '../base.model';

// Internal Chat models (SPEC-2026-07-internal-chat, T-16).
// Manual mirror of trendmulti-apps/libs/trendmulti-entity/src/entity/chat/
// chat-channel-member.entity.ts — enum values MUST stay byte-identical to the
// backend contract.

export enum ChatMemberRoleEnum {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export enum ChatNotificationLevelEnum {
  ALL = 'ALL',
  MENTIONS = 'MENTIONS',
  NONE = 'NONE',
}

export interface ChatChannelMember extends Base {
  /** ChatChannel id */
  channel: string;
  /** User id (appdb) — string only, never populated */
  user: string;
  /** Company id (appdb) — string only, never populated */
  company: string;
  role: ChatMemberRoleEnum;
  lastReadAt?: Date;
  notificationLevel: ChatNotificationLevelEnum;
  /** user explicitly marked the conversation as unread */
  manualUnread: boolean;
}
